import {useNavigate } from 'react-router-dom';
import {
  Alert,
  Box,
  Button,
  Container, 
  Divider, 
  Grid,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  Stack,
  Typography, 
} from '@mui/material';   
import SendIcon from '@mui/icons-material/Send';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import HomeIcon from '@mui/icons-material/Home'; 
const Checksign  = ({ 
  switchlogin
}: {  
  switchlogin: () => void 
}) => { 
  const nagate= useNavigate();
  const Navigato = (ds:string) => { 
    nagate(ds); 
};

  return (
    <>
      <Box sx={{ color: 'text.secondary',marginTop:5 }}> 
          <Grid container justifyContent="center" spacing={2}>  
          <Stack direction="column" alignItems="center" spacing={2}>
          
           <Alert variant="filled" severity="warning"> 
            <Typography sx={{ color: 'text.secondary' }}>
            Sorry,You need Sign in with polygon to the dapp! 
            </Typography>  
            </Alert>
            <Typography variant="h4" paragraph>
            <Button variant="contained" size="large"  onClick={switchlogin}>Sign</Button>
            </Typography>
            <List
              sx={{ width: '100%', maxWidth: 450, bgcolor: 'background.paper' }}
              component="nav"
              aria-labelledby="nested-list-subheader"
              subheader={
                <ListSubheader component="div" id="nested-list-subheader">
                 You can go:
                </ListSubheader>
              }
            >
           
              <ListItemButton   onClick={() =>  Navigato('/')} >
                <ListItemIcon>
                  <HomeIcon />
                </ListItemIcon>
                <ListItemText primary="Go to Home" />
              </ListItemButton>
            </List> 
            </Stack>
          </Grid> 
      </Box>
    </>
  );
}; 
 
export default Checksign;
